import {DealPayrollGradeCode} from './deal-payroll.model';

export const POSITION_KEY_SEPARATOR = '\u001f';
export const DEAL_PAYROLL_SETTINGS_EMPTY_LENGTH = 0;
export const EMPTY_SETTING_VALUE = '—';
export const COEFFICIENT_MODE_KEY_PREFIX = 'DEAL_PAYROLL_COEFFICIENT_MODE_VALUE_';
export const DEAL_PAYROLL_SETTINGS_EMPTY_TEXT = '';
export const DEAL_PAYROLL_SETTINGS_FIRST_INDEX = 0;
export const SINGLE_UNIT_COUNT = 1;
export const DEAL_PAYROLL_SETTINGS_STRING_TYPE = 'string';
export const MINIMUM_NON_NEGATIVE_VALUE = 0;
export const MAXIMUM_COEFFICIENT_VALUE = 100;
export const MAXIMUM_HOURLY_RATE_VALUE = 1000000;
export const FOUR_DECIMAL_SCALE_FACTOR = 10000;
export const DECIMAL_ROUNDING_TOLERANCE = 0.0000001;
export const TEAM_UNIT_TYPE = 'TEAM';
export const TEAM_R_CODE = 'R';
export const TEAM_H_CODE = 'H';
export const REQUIRED_TEAM_UNIT_COUNT = 2;
export const REQUIRED_GRADE_SEQUENCE: DealPayrollGradeCode[] = [
  'JUNIOR_MINUS' as DealPayrollGradeCode,
  'JUNIOR' as DealPayrollGradeCode,
  'JUNIOR_PLUS' as DealPayrollGradeCode,
  'MIDDLE_MINUS' as DealPayrollGradeCode,
  'MIDDLE' as DealPayrollGradeCode,
  'MIDDLE_PLUS' as DealPayrollGradeCode,
  'SENIOR_MINUS' as DealPayrollGradeCode,
  'SENIOR' as DealPayrollGradeCode,
  'SENIOR_PLUS' as DealPayrollGradeCode
];
export const DEAL_PAYROLL_SETTINGS_LOAD_ERROR_KEY = 'DEAL_PAYROLL_SETTINGS_LOAD_ERROR';
export const DEAL_PAYROLL_SETTINGS_FORBIDDEN_KEY = 'DEAL_PAYROLL_SETTINGS_FORBIDDEN';
export const POSITION_REQUIRED_KEY = 'DEAL_PAYROLL_GROUP_POSITIONS_INVALID';
export const GRADE_REQUIRED_KEY = 'DEAL_PAYROLL_GROUP_GRADES_INVALID';
export const AREAS_INVALID_KEY = 'DEAL_PAYROLL_SETTINGS_AREAS_INVALID';
export const AREA_CATALOG_UNAVAILABLE_EMPTY_KEY = 'DEAL_PAYROLL_AREA_CATALOG_UNAVAILABLE_EMPTY';
export const TEAM_COEFFICIENTS_INVALID_KEY = 'DEAL_PAYROLL_SETTINGS_TEAM_COEFFICIENTS_INVALID';
export const MASTER_COEFFICIENT_INVALID_KEY = 'DEAL_PAYROLL_ISSUE_MASTER_COEFFICIENT_INVALID';
export const BUSINESS_TRIP_COEFFICIENT_INVALID_KEY = 'DEAL_PAYROLL_ISSUE_BUSINESS_TRIP_COEFFICIENT_INVALID';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/deal-payroll-settings.constants.ts